import React from 'react';
import styled from 'styled-components';
import { LogoWrap, LogoIcon, LogoText } from '../Dashboard/Dashboard';

const AppHeader = styled.header`
  padding: 1rem;
  background-color: #434c5e;

  @media (min-width: 40rem) {
    padding: 1rem 2rem;
  }
`;

const CSVHeader = () => (
  <AppHeader>
    <LogoWrap>
      <LogoIcon />
      <LogoText>HeavyData</LogoText>
    </LogoWrap>
  </AppHeader>
);

export default CSVHeader;
